/* eslint-disable react/prop-types */
import React, {  useState } from 'react'
import PropTypes from 'prop-types'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import WarningModal from 'component/scheduleBlock/WarningModal'
import UseConsumeModalErrorNew from 'component/useConsume/UseConsumeErrorModalNew'
import Select from '../Select/Select'
import { isEmpty } from 'utils/validations'

const PictogramAddModal = ({
  closeModal,
  submit,
  translate,
  options
}) => {
  const getOptions = () => (options || []).map((option) => ({
      value: option.cdMission,
      label: option.dsMission,
    }))

  const [openUploadErrorModal, setOpenUploadErrorModal] = useState(false)
  const [missions,setMissions] = useState([])

  const [warningModal,setWarningModal] = useState(false)

  const renderUploadErrorModal = () => {
    if(!openUploadErrorModal) return
    return (
      <UseConsumeModalErrorNew
        above
        onConfirm={() => setOpenUploadErrorModal(false)}
        text={"Houve um erro ao adicionar a imagem no pictograma"}
        title={'Ops!'}
        details={"Formato não suportado"}
        okButton={'Tentar novamente'}
      />
    )
  }

  const isButtonDisabled = isEmpty(missions)

  const handleSubmit = () => {
    const form = {dsMission: missions}
    submit(form)
  }

  const handleCloseModal = () => {
    if(!isEmpty(missions)) {
      setWarningModal(true)
    }
    else {
      closeModal()
    }
  }

  const renderWarningModalWeekly = () => {

    if(!warningModal) return
    const handleConfirm = () => {
      setMissions([])
      setWarningModal(false)
      closeModal()
    }

    const handleCancel = () => {
      setWarningModal(false)
    }

    return (
      <WarningModal
        customClass='pictogram-warning-modal'
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        customText='Gostaria de sair sem salvar a tela de cadastro mesmo assim?'
        translate={translate}
      />
    )

  }

  return (
    <>
      {renderUploadErrorModal()}
      {renderWarningModalWeekly()}
    
      <Modal
        modalWidth={'408px'}
        onCloseModal={handleCloseModal}
        size='md'
        under
        className={`use-consume-approvers-modal  ${warningModal ? 'hide-shadow' : ''}`}
      >
        <h3 style={{fontSize: '24px', marginBottom:'32px', marginTop: '-1px', paddingTop: '4px'}}>
          <strong style={{color: 'black'}}>Nova aprovação</strong>
        </h3>

        <Select
          label='Aprovação'
          placeholder='Selecione uma ou mais aprovações'
          fill
          required
          groupOptions
          selectAll
          values={missions}
          onChange={(value) => {
            const dsMissions = value.map(v => v.label)
            setMissions(dsMissions)
            
          }}
          validateValue={(value) => !!value && value.length > 0}
          options={getOptions()}
          isMulti
        />
      
        <div className='mission-block-new-modal-actions'>

          <button
            disabled={isButtonDisabled}
            onClick={handleSubmit}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={handleCloseModal}
            className='mission-cancel'
          >
          {translate('cancel_button_label')}
          </button>

        </div>
      </Modal>
    </>
 )
}

PictogramAddModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  handleAttributeAlreadyExists: PropTypes.func,
  user:PropTypes.object,
  fetchMissionsOptions: PropTypes.array,
  options: PropTypes.object,
  missionOptions: PropTypes.object,
  attributeAlreadyExists: PropTypes.func

}

export default Form()(PictogramAddModal)

export { PictogramAddModal }
